import type {ColSpec} from "../../../../components/table/MithraTableHeadColumns";
import type ProfileStore from "../../../../stores/ProfileStore";
import type AuthStore from "../../../../authentication/AuthStore";

export function getParentSupplierNormalizationSupplierColumns(p: ProfileStore): Array<ColSpec> {
    return [
        {cls: 'col-dropdown', txt: '', align: 'center', width: 20},
        {cls: 'col-sp_n_suppliers xs-padding', txt: '', width: 10},
        {cls: 'col-choose-parent', txt: p.p.parentSupplierAltName ?? 'Parent Supplier', width: 320},
        {cls: 'col-sp_spend', txt: 'Spend', width: 128},
        {cls: 'col-l1s', txt: 'L1s of parent', width: 320},
        {cls: 'col-region', txt: 'Region'},
        {cls: 'col-edit', txt: '', width: 20},
        // {cls: 'col-bus', txt: 'Entity'},
        // {cls: 'col-s_cats', txt: ''},
        // {cls: 'col-s_YN', txt: 'Approve', align: 'right' as const},
    ]
}


export function getSupplierNormalizationSupplierColumns(p: ProfileStore, auth: AuthStore) {
    const arr: (ColSpec | null)[] = [
        {cls: 'col-choose-parent', txt: '', width: 350},
        p.p.showSupplierIdInSupplierNormalization
            ? {cls: 'col-s_id', txt: p.supplierIdDataName, width: 100}
            : null,
        {cls: 'col-s_name', txt: 'Child supplier', width: 300},
        {cls: 'col-s_spend', txt: 'Spend', align: 'right', width: 105},
        p.p.showSupplierCountryInSupplierNormalization
            ? {cls: 'col-s_country_code', txt: 'Country', width: 50}
            : null,
        {cls: 'col-s_city', txt: 'Location', width: 100},
        p.p.showBusinessUnitInSupplierNormalization ? {cls: '', txt: p.buDataName} : null,
        p.p.showSupplierVatInSupplierNormalization
            ? {cls: '', txt: 'VAT', width: 50}
            : null,
        {cls: 'col-s_l1s', txt: 'L1(s) of child', width: 400},
        auth.isMithraStaffGroup ? {cls: 'col-review_id', txt: 'Reviewer', width: 100, isMithraStaffOnly: true} : null,
        // {cls: 'col-s_suggestion_score', txt: 'Suggestion score'},
    ]
    return arr.filter(c => c) as ColSpec[];
}

export function getSupplierCommonSupplierColumns(p: ProfileStore, auth: AuthStore) {
    const arr: (ColSpec | null)[] = [
        // {cls: 'col-choose-parent', txt: '', width: 350},
        p.p.showSupplierIdInSupplierNormalization
            ? {cls: 'col-s_id', txt: p.supplierIdDataName, width: 100}
            : null,
        {cls: 'col-s_name', txt: 'Child supplier', width: 300},
        {cls: 'col-s_spend', txt: 'Spend', align: 'right', width: 105},
        {cls: 'col-s_city', txt: 'Location', width: 100},
        {cls: 'col-s_l1s', txt: 'L1(s) of child', width: 400},
        auth.isMithraStaffGroup ? {
            cls: 'col-review_id',
            txt: 'Reviewer ID',
            width: 100,
            isMithraStaffOnly: true
        } : null,
        // {cls: 'col-s_suggestion_score', txt: 'Suggestion score'},
        {cls: 'col-dataset', txt: 'Dataset', width: 300},
    ]
    return arr.filter(c => c) as ColSpec[];
}

